<mat-dialog-content>
  <div class="dialog-content-container">

    <div class="dialog-title text-center mb-4">{{ title }}</div>

    <div class="form-group mb-3">
      <p>Enter POS ID</p>
      <mat-form-field appearance="outline" class="w-100">
        <input type="text" matInput [(ngModel)]="posId">
        <mat-hint class="text-danger">
          *For example, Device 1 should be 'pos01' and Device 2 should be 'pos02'.<br>
          *Please keep these values unchanged.
        </mat-hint>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons-container d-flex justify-content-center w-100 p-3">
    <div class="cancel-button-container col-4 me-3">
      <button class="btn btn-light border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Close</span>
      </button>
    </div>
    <div class="search-button-container col-8">
      <button
        class="btn btn-primary text-white w-100 h-100 d-flex align-items-center justify-content-center"
        (click)="submit()">
        <i class="fa fa-search me-2"></i>
        <span>Update Printer Config</span>
      </button>
    </div>
  </div>


</mat-dialog-actions>
